var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chat-container" }, [
    (_vm.chatsOpened && !_vm.chatUserDetails && _vm.$uiHelpers.isPortrait) ||
    !_vm.$uiHelpers.isPortrait
      ? _c("div", { staticClass: "chat-list chat-card" }, [
          _vm.$store.getters["session/userIsProfessional"]
            ? _c(
                "div",
                { staticClass: "pat-profs-select" },
                [
                  _c(
                    "base-button",
                    {
                      staticClass: "mr-1 d-flex justify-content-center",
                      staticStyle: { width: "50%" },
                      attrs: { white: _vm.userTypeChatProf },
                      on: {
                        click: function($event) {
                          return _vm.setUserType(_vm.PATIENT_ROLE)
                        }
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("chats.patients")))])]
                  ),
                  _c(
                    "base-button",
                    {
                      staticClass: "ml-1 d-flex justify-content-center",
                      staticStyle: { width: "50%" },
                      attrs: { white: !_vm.userTypeChatProf },
                      on: {
                        click: function($event) {
                          return _vm.setUserType(_vm.PROFESSIONAL_ROLE)
                        }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("chats.professionals")))
                      ])
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", [
            _c(
              "ul",
              [
                _vm.$store.getters["session/userIsProfessional"]
                  ? _c(
                      "li",
                      {
                        staticClass: "chat-list-item",
                        on: {
                          click: function($event) {
                            return _vm.toggleShowDialog(
                              "showAdministrativeModal"
                            )
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "photo-name-wrapper" }, [
                          _c("div", { staticClass: "photo-align" }, [
                            _c("img", {
                              staticClass: "chat-list-photo chat-list-icon",
                              attrs: { src: _vm.defaultImg, alt: "" }
                            })
                          ]),
                          _vm._v(" "),
                          _vm.userTypeChatProf
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.$t("chats.contact-prof")))
                              ])
                            : _c("span", [
                                _vm._v(_vm._s(_vm.$t("chats.contact-patient")))
                              ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.chatList, function(chat) {
                  return _c(
                    "li",
                    {
                      key: chat.idAppointment,
                      staticClass: "chat-list-item",
                      class: [_vm.chatUserDetails === chat ? "selected" : ""],
                      on: {
                        click: function($event) {
                          return _vm.selectChat(chat)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "photo-name-wrapper" }, [
                        _c(
                          "div",
                          {
                            class: [!chat.createdByDoctor ? "photo-align" : ""]
                          },
                          [
                            _c("span", {
                              staticClass: "contact-status",
                              class: [
                                chat.conexionState === "online"
                                  ? "connected"
                                  : ""
                              ]
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "chat-list-photo",
                              attrs: { src: chat.urlPhoto, alt: "" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("b-row", { staticClass: "chat-list-name" }, [
                              _c("span", [_vm._v(_vm._s(chat.name))])
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        chat.numMessagesPendingRead
                          ? _c("span", { staticClass: "unread-messages" }, [
                              _vm._v(_vm._s(chat.numMessagesPendingRead))
                            ])
                          : _vm._e()
                      ])
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.chatIsPast
                  ? _c(
                      "li",
                      {
                        staticClass: "chat-list-item",
                        on: {
                          "~click": function($event) {
                            return _vm.$router.push("/patient/chats")
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "photo-name-wrapper" }, [
                          _vm._m(0),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.$t("chats.view-all")))])
                        ])
                      ]
                    )
                  : _c(
                      "li",
                      {
                        staticClass: "chat-list-item",
                        on: {
                          click: function($event) {
                            return _vm.getPastChats()
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "photo-name-wrapper" }, [
                          _vm._m(1),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("chats.finished-chats")))
                          ])
                        ])
                      ]
                    )
              ],
              2
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.chatUserDetails
      ? _c("div", { staticClass: "chat-box chat-card" }, [
          _c(
            "div",
            { staticClass: "chat-header" },
            [
              _vm.$uiHelpers.isPortrait
                ? _c("b-icon-arrow-left", {
                    staticClass: "back-arrow",
                    staticStyle: { cursor: "pointer" },
                    on: {
                      click: function($event) {
                        return _vm.$store.commit("chat/unselectChat")
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("img", {
                staticClass: "photo",
                attrs: { src: _vm.chatUserDetails.urlPhoto, alt: "" }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "user-info",
                  style: _vm.chatUserDetails.customPageUrl
                    ? "cursor: pointer;"
                    : "",
                  on: { click: _vm.goToProfPage }
                },
                [
                  _c("b-row", [
                    _c("p", { staticClass: "chat-name" }, [
                      _vm._v(_vm._s(_vm.chatUserDetails.name))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("b-row", [
                    _c("p", { staticClass: "chat-id" }, [
                      _vm._v("Id: " + _vm._s(_vm.chatUserDetails.idAppointment))
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm.chatUserDetails.canCancel
                ? _c(
                    "div",
                    { staticClass: "cancel-consultation" },
                    [
                      _c(
                        "base-button",
                        {
                          attrs: { red: "", textColor: _vm.SECONDARY },
                          on: {
                            click: function($event) {
                              return _vm.$helpers.goToPatientWebApp(
                                "appointments/cancel/" +
                                  _vm.chatUserDetails.idAppointment,
                                _vm.$apiToken
                              )
                            }
                          }
                        },
                        [
                          _c("b-icon-x-circle"),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("chats.cancel-chat")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "messageList",
              staticClass: "chat-content",
              on: {
                "&scroll": function($event) {
                  return _vm.showScrollBottomButtonHandler()
                }
              }
            },
            [
              _c(
                "ul",
                _vm._l(_vm.chatMessages, function(msg, index) {
                  return _c(
                    "li",
                    { key: msg.chatMessageId },
                    [
                      _vm.$store.state.chat.messagesPendingReadLabel > 0 &&
                      index === _vm.firstUnreadMessageIndex
                        ? _c("div", {
                            ref: "messagesPendingRead",
                            refInFor: true,
                            staticClass: "messages-pending-read"
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("chat-message", {
                        attrs: {
                          msg: msg,
                          userPhoto: _vm.chatUserDetails.urlPhoto
                        }
                      })
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("base-dialog", {
                attrs: {
                  content: _vm.$t("chats.finish-chat-message"),
                  okBtnText: _vm.$t("yes"),
                  cancelBtnText: _vm.$t("no"),
                  okFn: function() {
                    _vm.finishChatMessage()
                  },
                  cancelFn: function() {
                    _vm.$store.commit("chat/toggleShowDialog", "finish")
                  }
                },
                model: {
                  value: _vm.$store.state.chat.showDialog.finish,
                  callback: function($$v) {
                    _vm.$set(_vm.$store.state.chat.showDialog, "finish", $$v)
                  },
                  expression: "$store.state.chat.showDialog.finish"
                }
              }),
              _vm._v(" "),
              _c("base-dialog", {
                attrs: {
                  content: _vm.$t("chats.emit-eprescription-message"),
                  okBtnText: _vm.$t("continue"),
                  okFn: function() {
                    _vm.emitEPrescription()
                  },
                  cancelFn: function() {
                    _vm.$store.commit("chat/toggleShowDialog", "ePrescription")
                  }
                },
                model: {
                  value: _vm.$store.state.chat.showDialog.ePrescription,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.$store.state.chat.showDialog,
                      "ePrescription",
                      $$v
                    )
                  },
                  expression: "$store.state.chat.showDialog.ePrescription"
                }
              }),
              _vm._v(" "),
              _c("cancel-appointment-modal", {
                attrs: {
                  showDialog: _vm.showCancelModal,
                  appointmentId: _vm.chatUserDetails.idAppointment
                },
                on: {
                  toggleCancelAppointment: function($event) {
                    return _vm.toggleShowDialog("showCancelModal")
                  }
                }
              }),
              _vm._v(" "),
              _c("administrative-chat-modal", {
                attrs: {
                  showDialog: _vm.showAdministrativeModal,
                  userTypeChatProf: _vm.userTypeChatProf
                },
                on: {
                  toggleShowAdministrativeChat: function($event) {
                    return _vm.toggleShowDialog("showAdministrativeModal")
                  }
                }
              }),
              _vm._v(" "),
              _c("consolidate-appointment-modal", {
                attrs: {
                  value: _vm.showFinishModal,
                  isBillable:
                    _vm.chatUserDetails.showBillingSelectorOnConsolidate
                },
                on: { consolidate: _vm.consolidateChat }
              }),
              _vm._v(" "),
              _vm.showScrollBottomButton
                ? _c(
                    "button",
                    {
                      staticClass: "scroll-end-btn",
                      on: {
                        click: function($event) {
                          return _vm.$uiHelpers.scrollBottom(
                            _vm.$refs.messageList,
                            true
                          )
                        }
                      }
                    },
                    [_c("b-icon-arrow-down", { staticClass: "icon" })],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          !_vm.chatUserDetails.terminated
            ? _c(
                "div",
                { ref: "messageInput" },
                [
                  _c("chat-message-input"),
                  _vm._v(" "),
                  _vm.chatUserDetails.canFinish ||
                  _vm.chatUserDetails.ePrescriptionAvailable
                    ? _c(
                        "b-row",
                        { staticClass: "finish-consultation-options" },
                        [
                          _vm.chatUserDetails.ePrescriptionAvailable
                            ? _c(
                                "b-row",
                                {
                                  staticClass: "e-prescription",
                                  on: {
                                    click: function($event) {
                                      return _vm.$store.commit(
                                        "chat/toggleShowDialog",
                                        "ePrescription"
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "p",
                                    [
                                      _c("b-icon-file-medical"),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("chats.emit-eprescription")
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.chatUserDetails.canFinish
                            ? _c(
                                "b-row",
                                {
                                  staticClass: "finish-consultation",
                                  on: {
                                    click: function($event) {
                                      return _vm.$store.commit(
                                        "chat/toggleShowDialog",
                                        "finish"
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "p",
                                    [
                                      _c("b-icon-telephone-x-fill"),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("chats.finish-chat"))
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm.chatUserDetails.terminated && !_vm.chatUserDetails.reviewed
            ? _c(
                "div",
                { staticClass: " d-flex justify-content-center" },
                [
                  _c(
                    "base-button",
                    {
                      staticClass: "mb-3",
                      on: {
                        click: function($event) {
                          return _vm.$helpers.goToPatientWebApp(
                            "appointments/review/" +
                              _vm.chatUserDetails.idAppointment,
                            _vm.$apiToken
                          )
                        }
                      }
                    },
                    [
                      _c("b-icon-hand-thumbs-up-fill", { staticClass: "mr-2" }),
                      _c("span", [_vm._v(_vm._s(this.$t("review")))])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ])
      : !_vm.chatsOpened
      ? _c(
          "div",
          {
            staticClass:
              "chat-box chat-card align-items-center justify-content-center"
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.$t("chats.no-active-chat")))]),
            _vm._v(" "),
            _c(
              "base-button",
              {
                staticClass: "mt-2",
                on: {
                  click: function($event) {
                    return _vm.$router.push(
                      "/patient/search?appointmentType=" + _vm.CHAT
                    )
                  }
                }
              },
              [_c("span", [_vm._v(_vm._s(this.$t("chats.ask-for-new-chat")))])]
            ),
            _vm._v(" "),
            _vm.$uiHelpers.isPortrait
              ? _c(
                  "base-button",
                  {
                    staticClass: "mt-2",
                    on: {
                      click: function($event) {
                        return _vm.getPastChats()
                      }
                    }
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(this.$t("chats.finished-chats")))
                    ])
                  ]
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "photo-align" }, [
      _c("img", {
        staticClass: "chat-list-photo chat-list-icon",
        attrs: {
          src:
            "/static-appopensalud/img/icons/morillas-svg-icons/primary/doc-icon-blue.svg",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "photo-align" }, [
      _c("img", {
        staticClass: "chat-list-photo chat-list-icon",
        attrs: {
          src:
            "/static-appopensalud/img/icons/morillas-svg-icons/primary/doc-icon-blue.svg",
          alt: ""
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73c31155", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73c31155","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/chat-interconsultations/Chat.vue
// module id = 4097
// module chunks = 14